const account = {
    accountInformation: 'Account Information',
    emailAddress: 'Email address',
    username: 'Username',
    yourPlan: 'Your Plan',
    about: 'About Me',
    aboutDescription: 'I am a fantastic customer.',
    creditsRemaining: 'Credits remaining',
    buyMoreUpgrade: 'Buy More/Upgrade',
    manageSubscription: 'Manage Subscription',
    logout: 'Logout',
    logoutConfirmation: 'Confirm Logout',
    logoutConfirmMessage: 'Are you sure you want to logout?',
    deleteAccount: 'Delete Account',
    deleteAccountConfirmation: 'Are you sure you want to delete your account?',
    deleteAccountWarning: 'This action cannot be undone. All your data will be permanently deleted.',
    deleteAccountButton: 'Delete My Account',
    deleteAccountInputPlaceholder: 'Type "delete" to confirm',
    deleteAccountInputError: 'Type "delete" to confirm account deletion',
    deleteAccountPasswordPlaceholder: 'Enter your password',
    deleteAccountPasswordRequired: 'Password is required',
    changePassword: 'Change Password',
    changePasswordDescription: 'Update your account password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    passwordChanged: 'Password changed successfully',
    passwordChangeError: 'Error changing password',
    currentPasswordWrong: 'Current password is incorrect',
    passwordChangedRedirect: 'Password changed successfully. You will be redirected to login.',
    socialLoginNoPassword: 'This profile was created through Google login and does not have a password to change.',
    accountDeactivated: 'Account deactivated',
    accountReactivated: 'Account reactivated successfully',
    // Address form
    personalAddress: 'Personal Address',
    address: 'Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country',
    phone: 'Phone',
    edit: 'Edit',
    add: 'Add',
    save: 'Save',
    saving: 'Saving...',
    addressUpdated: 'Address updated successfully',
    addressUpdateError: 'Error updating address',
    noAddressData: 'No address information available',
    cancel: 'Cancel',
    confirm: 'Confirm'
};

export default account;
